export default "__VITE_ASSET__Bk_bRVLR__"